var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('template',{slot:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('estrelas')],1),_c('div',{staticClass:"col-12"},[_c('UltimasOS')],1)])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }